import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\icons-material\\esm\\ArrowOutward.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\icons-material\\esm\\Share.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\material\\Box\\Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\material\\Breadcrumbs\\Breadcrumbs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\material\\Container\\Container.js");
;
import(/* webpackMode: "eager" */ "D:\\medallion-homes\\node_modules\\@mui\\material\\Grid2\\Grid2.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\medallion-homes\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "D:\\medallion-homes\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "D:\\medallion-homes\\src\\app\\residential-portfolio\\styles\\Hero.module.css");
;
import(/* webpackMode: "eager" */ "D:\\medallion-homes\\src\\app\\css\\status_chip.css");
;
import(/* webpackMode: "eager" */ "D:\\medallion-homes\\src\\app\\residential-portfolio\\styles\\Details.module.css");
